import { useSEO } from "@/hooks/useSEO";
import { SeoPageLayout } from "@/components/seo/SeoPageLayout";
import { SeoSection } from "@/components/seo/SeoContent";
import { Link } from "react-router-dom";

const SITE = "https://www.regard-de-nature.fr";

const NaturopatheMontesquieu = () => {
  useSEO({
    title: "Naturopathe à Montesquieu-Lauragais (31450) – Laura Elie",
    description:
      "Naturopathe à Montesquieu-Lauragais : cabinet au calme, en pleine campagne du Lauragais. Stress, fatigue, sommeil, digestion. Consultations sur rendez-vous avec Laura Elie.",
    canonical: `${SITE}/naturopathe-montesquieu-lauragais`,
    jsonLd: {
      "@context": "https://schema.org",
      "@type": "LocalBusiness",
      name: "Regard de Nature – Laura Elie, Naturopathe (Montesquieu-Lauragais)",
      image: `${SITE}/regard-de-nature-logo.png`,
      "@id": `${SITE}/naturopathe-montesquieu-lauragais`,
      url: `${SITE}/naturopathe-montesquieu-lauragais`,
      telephone: "+33637031866",
      address: {
        "@type": "PostalAddress",
        streetAddress: "31 rue de l'ancien petit fossé",
        addressLocality: "Montesquieu-Lauragais",
        postalCode: "31450",
        addressCountry: "FR",
      },
      areaServed: [
        "Montesquieu-Lauragais",
        "Villefranche-de-Lauragais",
        "Nailloux",
        "Caraman",
        "Auterive",
        "Baziège",
        "Auriac-sur-Vendinelle",
        "Ayguesvives",
        "Montgiscard",
        "Donneville",
        "Castanet-Tolosan",
        "Lauragais",
        "Sud toulousain",
      ],
      priceRange: "€€",
    },
  });

  return (
    <SeoPageLayout
      h1="Naturopathe à Montesquieu-Lauragais"
      intro="Un cabinet au calme, en pleine campagne du Lauragais, pour prendre le temps de faire le point sur votre vitalité."
    >
      <SeoSection title="Pourquoi consulter à Montesquieu-Lauragais ?">
        <p>
          Mon cabinet principal se situe à <strong>Montesquieu-Lauragais (31450)</strong>, à mi-chemin entre
          Toulouse et Castelnaudary. Un cadre rural, lumineux et apaisé, qui invite à ralentir dès l'arrivée —
          stationnement facile, environnement calme, pas de salle d'attente bruyante.
        </p>
        <p>
          J'y reçois des personnes venues de tout le <strong>Lauragais et du sud toulousain</strong> :
          Villefranche-de-Lauragais, Nailloux, Caraman, Auterive, Baziège, Auriac-sur-Vendinelle, Ayguesvives,
          Montgiscard, Donneville, Castanet-Tolosan, Calmont, Cintegabelle, Mauremont, Gardouch, Renneville.
          L'accès est simple via l'A66 et l'A61.
        </p>
        <p>
          Si vous habitez plutôt côté Villefranche, je consulte également chaque jeudi matin à{" "}
          <Link to="/naturopathe-villefranche-de-lauragais" className="text-primary underline hover:text-secondary">
            Villefranche-de-Lauragais
          </Link>
          , à La Maison Céleste.
        </p>
      </SeoSection>

      <SeoSection title="Mes accompagnements">
        <ul className="space-y-2">
          <li>
            👉{" "}
            <Link to="/naturopathe-stress" className="text-primary underline hover:text-secondary">
              Accompagnement du stress
            </Link>
          </li>
          <li>
            👉{" "}
            <Link to="/naturopathe-fatigue" className="text-primary underline hover:text-secondary">
              Accompagnement de la fatigue
            </Link>
          </li>
          <li>
            👉{" "}
            <Link to="/naturopathe-sommeil" className="text-primary underline hover:text-secondary">
              Accompagnement du sommeil
            </Link>
          </li>
          <li>
            👉{" "}
            <Link to="/naturopathe-digestion" className="text-primary underline hover:text-secondary">
              Accompagnement digestion
            </Link>
          </li>
          <li>
            👉{" "}
            <Link to="/iridologie" className="text-primary underline hover:text-secondary">
              Iridologie
            </Link>
          </li>
          <li>
            👉{" "}
            <Link to="/fleurs-de-bach" className="text-primary underline hover:text-secondary">
              Fleurs de Bach
            </Link>
          </li>
        </ul>
      </SeoSection>
    </SeoPageLayout>
  );
};

export default NaturopatheMontesquieu;
